export const corrections: { [key: string]: string } = {
  مساوی: "=",
  مساویه: "=",
  "مساوی با": "=",
  "خط جدید": "\n",
  "خط تیره": " - ",
  کاما: " ،",

  // --- Hospital Departments & Wards ---
  "ای سی یو": "ICU",
  "سی سی یو": "CCU",
  "ان آی سی یو": "NICU",
  "پی آی سی یو": "PICU",
  "ای آر": "ER",
  "او آر": "OR",
  ریکاوری: "Recovery",
  "پست آپ": "Post-op",
  کلینیک: "Clinic",
  رادیولوژی: "Radiology",

  // --- Cardiology & Arrhythmias ---
  "ای سی جی": "ECG",
  "ای کی جی": "ECG",
  "ام آی": "MI",
  "سی ای دی": "CAD",
  "سی اچ اف": "CHF",
  "سی وی ای": "CVA",
  "دی وی تی": "DVT",
  "پی ای": "PE",
  "اچ تی ان": "HTN",
  هایپرتنشن: "Hypertension",
  اکو: "Echo",
  // Arrhythmias
  آریتمی: "Arrhythmia",
  "ای فیب": "AFib",
  "ای اف": "AF",
  فلاتر: "Flutter",
  "اس وی تی": "SVT",
  "وی تک": "V-Tach",
  "وی تی": "VT",
  "وی فیب": "V-Fib",
  "وی اف": "VF",
  "پی وی سی": "PVC",
  "تاکی کاردی": "Tachycardia",
  تاکیکاردی: "Tachycardia",
  "کاردی برادی": "Bradycardia",
  برادیکاردی: "Bradycardia",
  آسیستول: "Asystole",
  اسیستول: "Asystole",
  سیستول: "Systol",
  دیاستول: "Diastole",
  "ان ای بی پی": "NIBP",
  "ان آی بی پی": "NIBP",
  "هارت ریت": "HR",

  // --- Radiology & Imaging ---
  "اکس ری": "X-ray",
  "ایکس ری": "X-ray",
  "ایکس رای": "X-ray",
  گرافی: "Graphy",
  "چست اکس ری": "Chest X-ray",
  "سی تی اسکن": "CT Scan",
  "سی تی": "CT",
  سیتی: "CT",
  // "سی تی با کنتراست": "CT with contrast",
  // "سیتی با کنتراست": "CT with contrast",
  // "سی تی بدون کنتراست": "CT without contrast",
  // "سیتی بدون کنتراست": "CT without contrast",
  "ام آر آی": "MRI",
  " ام‌آر‌آی": "MRI",
  سونوگرافی: "Sonography",
  اولتراسوند: "Ultrasound",
  داپلر: "Doppler",
  ماموگرافی: "Mammography",
  آنژیوگرافی: "Angiography",

  // --- Laboratory & Blood Tests ---
  "سی بی سی": "CBC",
  "دبلیو بی سی": "WBC",
  "آر بی سی": "RBC",
  پلاکت: "Platelet",
  هموگلوبین: "Hemoglobin",
  "اچ بی": "Hb",
  "بی ام پی": "BMP",
  "سی ام پی": "CMP",
  "ال اف تی": "LFT",
  "آ ال تی": "ALT",
  "ای ال تی": "ALT",
  "آ اس تی": "AST",
  "ای اس تی": "AST",
  "پی تی": "PT",
  "پی تی تی": "PTT",
  "آی ان آر": "INR",
  "ای اس آر": "ESR",
  "سی آر پی": "CRP",
  "یو ای": "U/A",
  "یو سی": "U/C",
  "بی یو ان": "BUN",
  کراتینین: "Creatinine",
  "ای بی جی": "ABG",
  الکترولیت: "Electrolyte",
  سدیم: "Sodium",
  پتاسیم: "Potassium",
  کلسیم: "Calcium",
  "بلاد کالچر": "Blood Culture",
  "اف بی اس": "FBS",
  "بی سی": "BC",
  "پنل تیروئید": "Thyroid Panel",
  "پنل چربی": "Lipid Panel",

  // --- Pharmacology / Drugs (Common Classes) ---
  // Analgesics
  استامینوفن: "Acetaminophen",
  ایبوپروفن: "Ibuprofen",
  ناپروکسن: "Naproxen",
  دیکلوفناک: "Diclofenac",
  مورفین: "Morphine",
  ترامادول: "Tramadol",
  پتیدین: "Pethidine",
  // Antibiotics
  "پنی سیلین": "Penicillin",
  پنیسیلین: "Penicillin",
  پنسیلین: "Penicillin",
  "آموکسی‌ سیلین": "Amoxicillin",
  سفتریاکسون: "Ceftriaxone",
  سفازولین: "Cefazolin",
  مترونیدازول: "Metronidazole",
  ونکومایسین: "Vancomycin",
  سیپروفلوکساسین: "Ciprofloxacin",
  آزیترومایسین: "Azithromycin",
  // Cardiovascular
  آسپرین: "Aspirin",
  کلوپیدوگرل: "Clopidogrel",
  وارفارین: "Warfarin",
  هپارین: "Heparin",
  آتورواستاتین: "Atorvastatin",
  لوزارتان: "Losartan",
  کاپتوپریل: "Captopril",
  متوپرولول: "Metoprolol",
  نیتروگلیسرین: "Nitroglycerin",
  "نیترو گلیسرین": "Nitroglycerin",
  "ان جی تی": "NGT",
  دیگوکسین: "Digoxin",
  فوروزماید: "Furosemide",
  // GI Drugs
  امپرازول: "Omeprazole",
  پنتوپرازول: "Pantoprazole",
  رانیتیدین: "Ranitidine",
  "رانی تیدین": "Ranitidine",
  متوکلوپرامید: "Metoclopramide",
  // Endocrine Drugs
  متفورمین: "Metformin",
  انسولین: "Insulin",
  لووتیروکسین: "Levothyroxine",
  // Respiratory Drugs
  سالبوتامول: "Salbutamol",
  سالبوتامل: "Salbutamol",
  فلوتیکازون: "Fluticasone",
  // Steroids
  هیدروکورتیزون: "Hydrocortisone",
  دگزامتازون: "Dexamethasone",
  پردنیزولون: "Prednisolone",
  // Neurologic/Psychiatric
  سرترالین: "Sertraline",
  فلوکستین: "Fluoxetine",
  آلپرازولام: "Alprazolam",
  دیازپام: "Diazepam",
  "فنی‌ توئین": "Phenytoin",

  // --- Nursing, Injections & Routes ---
  "آی وی": "IV",
  "آی ام": "IM",
  "اس سی": "SC",
  "آی دی": "ID",
  سوند: "Catheter",
  آنژیوکت: "Angiocath",
  "ان جی تیوب": "NG Tube",
  "آی اند او": "I&O",
  "ان پی او": "NPO",
  // "سرم": "Saline",

  // --- Physiotherapy & Rehabilitation ---
  فیزیوتراپی: "Physiotherapy",
  "آر او ام": "ROM",
  "او تی": "OT",

  // --- General Medical Terms & Procedures ---
  "بی پی": "BP",
  "اچ آر": "HR",
  "آر آر": "RR",
  "بی ام آی": "BMI",
  "سی سی": "CC",
  "اچ پی آی": "HPI",
  "پی ام اچ": "PMH",
  "ان کا دی ای": "NKDA",
  "آر او اس": "ROS",
  اکیوت: "Acute",
  کرونیک: "Chronic",
  دیابت: "Diabetes",
  "دی ام": "DM",
  بیوپسی: "Biopsy",
  سرجری: "surgery",
  ریفر: "Refer",
  دیسشارژ: "Discharge",
  ادمیت: "Admit",
  کنسالت: "Consult",
  "فالو آپ": "Follow-up",
  چکاپ: "Checkup",
};
